import React from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import styles from "../Profile.module.scss";
import { FaInstagram, FaFacebook, FaTwitter, FaYoutube, FaPencilAlt } from "react-icons/fa";
import clinicImage from '../../../../images/CCImages/ClinicProfileIcon.png';

const ProfileView = ({
  clinic,
  clinicProfileData,
  handleEdit,
  handleCameraClick,
  fileInputRef,
  handleImageUpload,
}) => {

  return (
    <>
      <div className={styles["profile-edit-div"]}>
        <h3>My Profile</h3>
        <Button className="p-2" onClick={() => handleEdit(clinic)}>
          Edit Profile
        </Button>
      </div>
      <Row className={styles["profile-row"]}>
        <Col xl={6} className={styles["profile-col"]}>
          <div className={styles["profile-left-div"]}>
            <div className={styles["profile-left-img"]}>
              {
                clinic?.clinic_image && clinic?.clinic_image ? (
                  <img src={clinic?.clinic_image} alt="" />
                ) : (
                  <img src={clinicImage} alt="" />
                )
              }
              <FaPencilAlt onClick={handleCameraClick} />
              <input
                type="file"
                ref={fileInputRef}
                name="clinic_image"
                style={{ display: "none" }}
                onChange={handleImageUpload}
                accept="image/*"
              />
            </div>
            <div className={styles["profile-left-info"]}>
              <h3>{clinic?.clinicName}</h3>
              <p>{clinic?.tagline}</p>
              <div className={styles["profile-logo"]}>
                <span>
                  <a href={clinicProfileData?.instagram} target="_blank" rel="noreferrer">
                    <FaInstagram />
                  </a>
                </span>
                <span>
                  <a href={clinicProfileData?.facebook} target="_blank" rel="noreferrer">
                    <FaFacebook />
                  </a>
                </span>
                <span>
                  <a href={clinicProfileData?.twitter} target="_blank" rel="noreferrer">
                    <FaTwitter />
                  </a>
                </span>
                <span>
                  <a href={clinicProfileData?.youtube} target="_blank" rel="noreferrer">
                    <FaYoutube />
                  </a>
                </span>
              </div>
            </div>
          </div>
        </Col>
        <Col xl={6} className={styles["profile-col-right"]}>
          <ul className={styles["personal-info"]}>
            <li>
              <span className={styles["tittle"]}>Phone:</span>
              <span className={styles["text"]}>{clinic?.phone || "N/A"}</span>
            </li>
            <li>
              <span className={styles["tittle"]}>Alt Mobile:</span>
              <span className={styles["text"]}>
                {clinic?.alternateClinicPhone || "N/A"}
              </span>
            </li>
            <li>
              <span className={styles["tittle"]}>Email:</span>
              <span className={styles["text"]}>{clinic?.clinicEmail || "N/A"}</span>
            </li>
            <li>
              <span className={styles["tittle"]}>Address:</span>
              <span className={styles["text"]}>
                {clinic?.clinicAddress ? (
                  <>
                    {clinic.clinicAddress.plot &&
                      `${clinic.clinicAddress.plot}, `}
                    {clinic.clinicAddress.area &&
                      `${clinic.clinicAddress.area}, `}
                    {clinic.clinicAddress.street &&
                      `${clinic.clinicAddress.street}, `}
                    {clinic.clinicAddress.landMark &&
                      `${clinic.clinicAddress.landMark}, `}
                    {clinic.clinicAddress.city?.name &&
                      `${clinic.clinicAddress.city.name}, `}
                    {clinic?.clinicAddress?.state?.name &&
                      `${clinic.clinicAddress.state.name}, `}
                    {clinic.clinicAddress.country?.name &&
                      `${clinic.clinicAddress.country.name}, `}
                    {clinic.clinicAddress.pin && clinic.clinicAddress.pin}
                  </>
                ) : (
                  "N/A"
                )}
              </span>
            </li>
          </ul>
        </Col>
      </Row>
    </>
  );
};

export default ProfileView;
